import React, {useState} from 'react'
import Home from '../../pages/Home.js';
import Dashboard from '../../pages/Dashboard.js';
import ShareText from '../../pages/ShareText.js';
import { Routes, Route} from 'react-router-dom';
const Main = () => {
	const [modalText, setModalText] = useState('')
	const [fileLink, setFileLink] = useState('');
	const handleModalTitle = (modalTitle) => {
		setModalText(modalTitle);
	}
	const handleLink = (link) => {
		setFileLink(link);
	}
	return (
		<>
			<Routes>
				<Route path="/" element={<Home handleModalText={handleModalTitle} handleLink={handleLink}/> }/>
				<Route path="/dashboard" element={<Dashboard/>}/>
				<Route path="/share-text/:id" element={<ShareText title={modalText.trim()} link={fileLink} />} />
			</Routes>
		</>
	)
}

export default Main